<template>
    <div>
        <div class="card bg-light mb-0">
            <div class="card-header bg-dark text-white d-flex justify-content-between align-items-center">
                <h6 class="mb-0"><font-awesome-icon icon="plus-circle" /> Education</h6>
            </div>
            <div class="card-body bg-white position-relative">
                <b-row align-v="center" class="loader" v-if="is_saving">
                    <b-col>
                        <b-spinner></b-spinner>
                        <br><br>
                        <strong>Loading</strong>
                    </b-col>
                </b-row>
                <b-form @submit.prevent="save">

                    <b-form-group
                            label="Education Level:"
                            description="This field is required"
                    >
                        <select class="form-control form-control-sm" v-model="form.education_level_id"  required>
                            <option value="">Please Select</option>
                            <option v-for="education_level in education_levels" :value="education_level.id">
                                {{education_level.description}}
                            </option>
                        </select>
                    </b-form-group>
                    <b-form-group label="Institute:" description="This field is required">
                        <b-form-input v-model="form.institute" type="text" required size="sm"></b-form-input>
                    </b-form-group>
                    <b-form-group label="Major:" description="This field is required">
                        <b-form-input v-model="form.major" type="text" required size="sm"></b-form-input>
                    </b-form-group>
                    <b-form-group label="Year:" description="This field is required">
                        <b-form-input v-model="form.year" type="number" required size="sm"></b-form-input>
                    </b-form-group>
                    <b-form-group label="gpa:" description="This field is required">
                        <b-form-input v-model="form.gpa" type="number" step="any" required size="sm"></b-form-input>
                    </b-form-group>
                    <b-form-group label="Start Date:" description="This field is required">
                        <b-form-input v-model="form.start_date" type="date" required size="sm"></b-form-input>
                    </b-form-group>
                    <b-form-group label="End Date:" description="This field is required">
                        <b-form-input v-model="form.end_date" type="date" required size="sm"></b-form-input>
                    </b-form-group>
                    <div class="text-right mt-3">
                        <b-button type="submit" variant="dark" size="sm"><font-awesome-icon icon="save" /> Save</b-button>
                    </div>
                </b-form>
            </div>
        </div>
    </div>
</template>
<script>
    import SwalMixin from '@/views/mixins/Swal.js'
    export default {
        mixins:[SwalMixin],
        data() {
            return {
                is_saving:false,
                form:{
                    id:-1,
                    education_level_id:'',
                    institute:'',
                    major:'',
                    year:'',
                    gpa:'',
                    start_date:'',
                    end_date:''
                },
                education_levels:[]
            }
        },

        created(){
            this.getFields();
        },
        methods: {

            getFields(){
                this.is_saving=true;
                this.axios.get('maintenance/education-levels/all').then(response => {
                    this.education_levels=response.data;
                    this.is_saving=false;
                }).catch(error => console.log(error));
            },
            save() {
                this.swalConfirmSubmit((data) => {
                    if (data.value) {
                        this.is_saving = true;
                        this.form.manpower_id = this.$route.params.id;
                        this.axios.post('maintenance/manpowers/education/save', this.form).then(response => {
                            this.swalTransactionCompleted();
                            this.is_saving = false;
                            this.$emit('save');
                        }).catch(error => {
                            this.swal_transaction_error_data.text = error.response.data;
                            this.swalRequestError();
                            this.is_saving = false;
                        });
                    }
                });
            },
        }
    }
</script>
